import { Component } from '@angular/core';

@Component({
  selector: 'my-statistic',
  template: require('./statistic.component.html'),
  styles: [require('./statistic.component.scss')]
})

export class StatisticComponent{


  constructor() {

  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/statistic/statistic.component.ts